import { Dialog, DialogContent, Grid, Typography } from "@mui/material";
import { useState } from "react";
import {
  BackSizeCalculator,
  ElbowSizeCalculator,
} from "./Reuseables/SizeCalculators";

export default function SizeCalculators() {
  const [elbowSizeDialog, setElbowSizeDialog] = useState(false);
  const handleCloseElbowDialog = () => {
    setElbowSizeDialog(false);
  };
  const handleOpenElbowDialog = () => {
    setElbowSizeDialog(true);
  };

  const [backSizeDialog, setBackSizeDialog] = useState(false);
  const handleCloseBackDialog = () => {
    setBackSizeDialog(false);
  };
  const handleOpenBackDialog = () => {
    setBackSizeDialog(true);
  };
  return (
    <>
      <Grid
        container
        sx={{
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          },
        }}
      >
        <Grid item xs>
          <Grid container>
            <Grid item md={1} lg={1} xl={2} />
            <Grid item xs>
              <Typography mb={1} color="primary" variant="h5">
                Elbow size calculator
              </Typography>
              <img
                onClick={handleOpenElbowDialog}
                style={{ width: "100%", height: "400px", cursor: "pointer" }}
                alt="elbow-sizes"
                src="https://precure-cdn.azureedge.net/images/elbow_size_guide.png"
              />
              <ElbowSizeCalculator />
            </Grid>
            <Grid item md={1} lg={1} xl={2} />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container>
            <Grid item md={1} lg={1} xl={2} />
            <Grid item xs>
              <Typography mb={1} color="primary" variant="h5">
                Back size calculator
              </Typography>
              <img
                onClick={handleOpenBackDialog}
                style={{
                  width: "100%",
                  height: "400px",
                  cursor: "pointer",
                  borderRadius: 20,
                }}
                alt="back-sizes"
                src="https://precure-cdn.azureedge.net/images/temp_back_size_guide.png"
              />
              <BackSizeCalculator />
            </Grid>
            <Grid item md={1} lg={1} xl={2} />
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        onClose={handleCloseElbowDialog}
        open={elbowSizeDialog}
      >
        <DialogContent>
          <img
            onClick={handleCloseElbowDialog}
            style={{ width: "100%", height: "100%", cursor: "pointer" }}
            alt="elbow-sizes"
            src="https://precure-cdn.azureedge.net/images/elbow_size_guide.png"
          />
        </DialogContent>
      </Dialog>
      <Dialog fullScreen onClose={handleCloseBackDialog} open={backSizeDialog}>
        <DialogContent>
          <img
            onClick={handleCloseBackDialog}
            style={{ width: "100%", height: "100%", cursor: "pointer" }}
            alt="back-sizes"
            src="https://precure-cdn.azureedge.net/images/temp_back_size_guide.png"
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
